import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
const lgaCache = {};
function loadLgas(stateId) {
  if (!stateId || lgaCache[stateId]) return;
  lgaCache[stateId] = 'loading';
  app.request({
    method: 'GET',
    url: app.forum.attribute('apiUrl') + '/voucha-community/states/' + stateId + '/lgas'
  }).then(r => lgaCache[stateId] = r.lgas || []).catch(() => lgaCache[stateId] = []).finally(() => m.redraw());
}

/**
 * The My Community questions for a managed account: where it lives, state of origin, profession,
 * industry and field of study, from the same lists members choose from.
 * attrs: community (edited in place), options (from the accounts call)
 */
export default class CommunityFields extends Component {
  view() {
    const c = this.attrs.community;
    const o = this.attrs.options || {};
    if (!o.available) {
      return m("p", {
        className: "VEC-help"
      }, "My Community isn't switched on, so location, profession and study can't be set.");
    }
    const num = v => v ? parseInt(v, 10) : null;
    const select = function (value, onchange, items, empty, valueKey, groupKey) {
      if (valueKey === void 0) {
        valueKey = 'key';
      }
      if (groupKey === void 0) {
        groupKey = null;
      }
      let options;
      if (groupKey) {
        const groups = {};
        items.forEach(i => (groups[i[groupKey] || 'Other'] = groups[i[groupKey] || 'Other'] || []).push(i));
        options = Object.keys(groups).map(g => m("optgroup", {
          label: g
        }, groups[g].map(i => m("option", {
          value: i[valueKey]
        }, i.name))));
      } else {
        options = items.map(i => m("option", {
          value: i[valueKey]
        }, i.name));
      }
      return m("select", {
        className: "FormControl",
        value: value == null ? '' : String(value),
        onchange: e => onchange(e.target.value)
      }, m("option", {
        value: ""
      }, empty), options);
    };
    const lgaSelect = (stateId, value, onchange) => {
      if (!stateId) return m("select", {
        className: "FormControl",
        disabled: true
      }, m("option", null, "Choose a state first"));
      loadLgas(stateId);
      const list = Array.isArray(lgaCache[stateId]) ? lgaCache[stateId] : [];
      return select(value, v => onchange(num(v)), list, list.length ? 'LGA (optional)' : 'Loading…', 'id');
    };
    const inNigeria = c.country === 'NG';
    const top = (o.countries || []).filter(x => x.top);
    const rest = (o.countries || []).filter(x => !x.top);
    return m("div", {
      className: "VEC-community"
    }, m("div", {
      className: "VEC-community-head"
    }, "My Community"), m("div", {
      className: "VEC-fields"
    }, m("label", {
      className: "VEC-field"
    }, m("span", null, "Lives in (country)"), m("select", {
      className: "FormControl",
      value: c.country || '',
      onchange: e => {
        c.country = e.target.value;
        if (c.country !== 'NG') {
          c.resStateId = null;
          c.resLgaId = null;
        } else c.city = '';
      }
    }, m("option", {
      value: ""
    }, "Choose\u2026"), m("optgroup", {
      label: "Most common"
    }, top.map(x => m("option", {
      value: x.code
    }, x.name))), m("optgroup", {
      label: "All countries"
    }, rest.map(x => m("option", {
      value: x.code
    }, x.name))))), inNigeria ? [m("label", {
      className: "VEC-field"
    }, m("span", null, "State"), select(c.resStateId, v => {
      c.resStateId = num(v);
      c.resLgaId = null;
    }, o.states || [], 'Choose a state', 'id')), m("label", {
      className: "VEC-field"
    }, m("span", null, "LGA"), lgaSelect(c.resStateId, c.resLgaId, v => c.resLgaId = v))] : m("label", {
      className: "VEC-field"
    }, m("span", null, "City"), m("input", {
      className: "FormControl",
      value: c.city || '',
      placeholder: "e.g. Toronto",
      disabled: !c.country,
      oninput: e => c.city = e.target.value
    })), !inNigeria ? m("span", {
      className: "VEC-field is-spacer"
    }) : null, m("label", {
      className: "VEC-field"
    }, m("span", null, "State of origin"), select(c.originStateId, v => {
      c.originStateId = num(v);
      c.originLgaId = null;
    }, o.states || [], 'Choose a state', 'id')), m("label", {
      className: "VEC-field"
    }, m("span", null, "LGA of origin"), lgaSelect(c.originStateId, c.originLgaId, v => c.originLgaId = v)), m("span", {
      className: "VEC-field is-spacer"
    }), m("label", {
      className: "VEC-field"
    }, m("span", null, "Profession"), select(c.profession, v => {
      c.profession = v;
      if (v) c.professionOther = '';
    }, o.professions || [], 'Choose or type below', 'key', 'group'), !c.profession ? m("input", {
      className: "FormControl",
      value: c.professionOther || '',
      placeholder: "Not in the list? Type it",
      oninput: e => c.professionOther = e.target.value
    }) : null), m("label", {
      className: "VEC-field"
    }, m("span", null, "Industry"), select(c.industry, v => c.industry = v, o.industries || [], 'Optional')), m("label", {
      className: "VEC-field"
    }, m("span", null, "Field of study"), select(c.study, v => {
      c.study = v;
      if (v) c.studyOther = '';
    }, o.studies || [], 'Choose or type below', 'key', 'group'), !c.study ? m("input", {
      className: "FormControl",
      value: c.studyOther || '',
      placeholder: "Not in the list? Type it",
      oninput: e => c.studyOther = e.target.value
    }) : null)));
  }
}